import { atom } from 'recoil'
import { SiteMapElasticType } from '../shared/types'

const site_map_types = atom<SiteMapElasticType>({
  key: '@main/site-map-types-atom',
  default: '',
})

export default site_map_types
